var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:_vm.tagClass,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default"),_vm._v(" "),(_vm.closeable)?_c('div',{staticClass:"btn-close",on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }